<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tocchaptitle"><a id="contents"></a>C<span class="small">ONTENTS</span></h1>
<p class="toc"><a href="#/05_introduction#intro">Introduction</a></p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="toc"><a href="#/06_part01#p1">Part One: THE MOON</a></p>
<p class="toc"><a href="#/07_chapter01#c1">Mothers and Matriarchy: The Mythology and Psychology of the Moon</a></p>
<p class="toc1"><a href="#/07_chapter01#c1-1">by Liz Greene</a></p>
<p class="toc"><span href="#/08_chapter02#c2" title="Link target outside of Sample">First Love: The Moon as a Significator of Relationship</span></p>
<p class="toc1"><span href="#/08_chapter02#c2-1" title="Link target outside of Sample">by Howard Sasportas</span></p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="toc"><span href="#/09_part02#p2" title="Link target outside of Sample">Part Two: THE SUN</span></p>
<p class="toc"><span href="#/10_chapter03#c3" title="Link target outside of Sample">The Hero with a Thousand Faces: The Sun and the Development of Consciousness</span></p>
<p class="toc1"><span href="#/10_chapter03#c3-1" title="Link target outside of Sample">by Liz Greene</span></p>
<p class="toc"><span href="#/11_chapter04#c4" title="Link target outside of Sample">Sun, Father, and the Emergence of the Ego: The Father's Role in Individual Development</span></p>
<p class="toc1"><span href="#/11_chapter04#c4-1" title="Link target outside of Sample">by Howard Sasportas</span></p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="toc"><span href="#/12_part03#p3" title="Link target outside of Sample">Part Three: THE CONIUNCTIO</span></p>
<p class="toc"><span href="#/13_chapter05#c5" title="Link target outside of Sample">The Sun and Moon in the Horoscope: A Discussion Using Example Horoscopes</span></p>
<p class="toc1"><span href="#/13_chapter05#c5-1" title="Link target outside of Sample">by Liz Greene and Howard Sasportas</span></p>
<p class="toc"><span href="#/14_chapter06#c6" title="Link target outside of Sample">The Rhythm of Life: A Discussion of the Lunation Cycle</span></p>
<p class="toc1"><span href="#/14_chapter06#c6-1" title="Link target outside of Sample">by Liz Greene</span></p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="toc"><span href="#/15_aboutthecenter#about" title="Link target outside of Sample">About the Centre for Psychological Astrology</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_contents.vue?35e3445c